// extracted by mini-css-extract-plugin
module.exports = {"normal":"Index_normal__1KDUc","normalM":"Index_normalM__2-bgO","animationFade":"Index_animationFade__3kMzG"};